module.exports = __webpack_public_path__ + "img/y-103.745d87ab.png";